import * as React from 'react';
import {FileField, FileInput, SaveButton, SimpleForm, TextInput, Toolbar, useNotify, useRefresh} from 'react-admin';
import myDataProvider from "../data-provider-with-image-convert";
import {Dialog} from "@material-ui/core";

const MyToolbar = () => {
    return (
        <Toolbar>
            <SaveButton
                label="Mentés"
            />
        </Toolbar>
    );
};

export const RequestEditDialog = ({record, open, setOpen}: { record: any, open: boolean, setOpen: any }) => {
    const notify = useNotify();
    const refresh = useRefresh();

    return <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{
        style: {
            backgroundColor: 'black',
            boxShadow: 'none',
            width: '600px',
            paddingTop: '20px'
        },
    }}>
        <SimpleForm toolbar={<MyToolbar/>}
            onSubmit={async (values) => {
        await myDataProvider.update('request', {id: record.id, data: values}).then(res => {
            notify(`Sikeres módosítás`, {type: 'success'});
            refresh()
            setOpen(false)
        })
    }}>
        <TextInput source="insideNote"
                   label={"Belső megjegyzés"}
                   name={"insideNote"}
                   fullWidth
                   multiline/>
    </SimpleForm>
    </Dialog>
};
